import Control from './Control';
import drawGroupHover from '../../img/draw_grouphover.png';
import drawHover from '../../img/draw_hover.png';
import drawPressed from '../../img/draw_pressed.png';
import drawRest from '../../img/draw_rest.png';

export default class Draw extends Control {
  constructor(store, dispatcher) {
    super({
      tooltip: 'Draw (3)',
      mode: 'Draw',
      srcRest: drawRest,
      srcGroup: drawGroupHover,
      srcHover: drawHover,
      srcDown: drawPressed,
    }, store, dispatcher);
  }
}